export const VALUE_RANGES_KEY = 'valueRanges';
export const DEFAULT_VALUE_RANGES = {};

export const DEFAULT_FONT_COLOR = '#000000';
export const REVERSE_FONT_COLOR = '#FFFFFF';
